// Global axios auth: attaches a stored JWT to every API request so protected
// backend routes (payments, conversions, profile, rewards, ...) receive an
// Authorization header. Call sites that already set their own header
// (e.g. admin APIs) are left untouched.

import axios from "axios";
import { API_BASE_URL } from "../config";
import { attachGetRetryInterceptor } from "./axiosRetry";

axios.defaults.timeout = 25000;
attachGetRetryInterceptor(axios);

axios.interceptors.request.use((config) => {
  if (config.headers?.Authorization) return config;

  const url = config.url || "";
  const isApiRequest = url.startsWith(API_BASE_URL) || url.startsWith("/");
  if (!isApiRequest) return config;

  const token =
    localStorage.getItem("betbond_app_token") ||
    localStorage.getItem("adminToken");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
